export const xstateDevTools = process.env.devTools === "true";
